export const OPPORTUNITIES_TYPES = 'COLD'
